<template>
    <c-dialog ref="dialog" mode="slide" width="55vw" enable-flex mask-close>
        <div class="saas-channel-config">
            <div class="source-saas">
                <span class="label">来源商户：</span>
                <c-select :key="saasId" v-model="sourceSaasId" async :disabled="channelLoading" :search="{empty: true}" placeholder="请选择已配置同售渠道的商户" @search="searchSourceSaas" @change="sourceSaasChange"></c-select>
            </div>
            <div class="config-header">选择同售渠道</div>
            <div class="channel-list">
                <div v-for="(channel, index) in channelList" :key="channel.channel_id" class="channel-item" :class="{active: channel.checked}">
                    <div class="channel-header">
                        <c-checkbox :value="channel.checked" @change="toggleChannel(channel, $event)" :disabled="channel.is_enabled==2">
                            {{channel.channel_name}}
                            <span v-if="channel.is_enabled==2" style="color: red">(已禁用)</span>
                        </c-checkbox>
                    </div>
                    <div v-if="channel.checked" class="channel-body">
                        <div v-if="channel.owner_type == 2" class="platform-account">
                            <span class="label"><span class="required">*</span>平台店铺：</span>
                            <c-select v-model="channel.platform_account" :options="accountPoolOptions[channel.platform_code] || []" :disabled="channel.is_enabled==2" placeholder="请选择平台店铺账号"></c-select>
                            <span v-if="!channel.platform_account || isAccountExpired(channel)" class="account-tip" :class="{'is-expired': isAccountExpired(channel)}">{{ isAccountExpired(channel) ? '该账号授权已过期，请重新授权' : '请选择同售店铺，未选择将无法推送' }}</span>
                        </div>
                        <div class="consume-type">
                            <span class="label">同售积分消耗形式：</span>
                            <span class="type-tag">按阶梯比例</span>
                        </div>
                        <div class="tier-list">
                            <div v-for="(tier, tIndex) in channel.tier_list" :key="tIndex" class="tier-row">
                                <span class="row-label">售出价大于等于(≥)：</span>
                                <div class="input-wrap">
                                    <c-input type="number" v-model="tier.price" decimal="2" :range="[0.01, 999999]" append-text="元" :clear="false" placeholder="请输入售价" :disabled="channel.is_enabled==2"></c-input>
                                </div>
                                <span class="row-label" style="margin-left: 20px;">消耗渠道积分：</span>
                                <div class="input-wrap">
                                    <c-input type="number" v-model="tier.points" decimal="0" :range="[0, 999999]" append-text="积分" :clear="false" placeholder="请输入积分" :disabled="channel.is_enabled==2"></c-input>
                                </div>
                                <a v-if="channel.tier_list.length > 1 && channel.is_enabled != 2" class="link-btn delete" @click="removeTier(channel, tier, tIndex)"><i class="tf-trash"></i> 删除</a>
                            </div>
                        </div>
                        <div class="add-row" v-show="channel.is_enabled!=2">
                            <c-link icon="tf-add" @click="addTier(channel)">增加阶梯</c-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <template #button>
            <c-button color="main" size="dialog" :disabled="channelLoading" @click="saveHandle">提交保存</c-button>
            <c-button size="dialog" @click="cancelHandle">取消</c-button>
        </template>
    </c-dialog>
</template>

<script>
export default {
    name: 'saasChannelConfig',

    data() {
        return {
            saasId: 0,
            saasName: '',
            sourceSaasId: '',
            channelLoading: false,
            channelRequestId: 0,
            accountPoolCache: {},
            // 三方渠道店铺账号下拉选项（按 platform_code 分组，打开弹框即预取，保证已绑账号回显选中）
            accountPoolOptions: {},
            channelList: []
        }
    },

    methods: {
        /*********打开编辑框，初始化**********/
        open(data) {
            this.saasId = data && data.saas_id ? data.saas_id : 0;
            this.saasName = data && data.saas_name ? data.saas_name : '';
            this.sourceSaasId = '';
            this.channelList = [];
            this.accountPoolCache = {};
            this.accountPoolOptions = {};

            // 填充form表单
            this.$refs.dialog.open({
                title: '绑定同售渠道' + (this.saasName ? ' - ' + this.saasName : '')
            });

            // 查询渠道列表
            this.fetchChannelList();
        },

        /*******搜索已配置同售渠道的其他商户*****************/
        searchSourceSaas(keyword, resolve) {
            const saasId = this.saasId;
            this.request({
                url: '/sys_saas/options',
                data: {
                    keyword: keyword,
                    exclude_saas_id: saasId,
                    has_channel_config: 1
                },
                success: data => {
                    resolve(this.saasId === saasId && Array.isArray(data) ? data : []);
                },
                fail: () => { resolve([]); },
                error: () => { resolve([]); }
            });
        },

        /*******复制来源商户的渠道及阶梯配置，仅回填，提交后保存*****************/
        sourceSaasChange() {
            // 清空来源选择时保留已回填的数据，便于继续手动调整。
            if (!this.sourceSaasId) {
                this.channelRequestId++;
                this.channelLoading = false;
                return;
            }
            this.fetchChannelList(this.sourceSaasId);
        },

        /*******查询商户已配置的渠道列表*****************/
        fetchChannelList(sourceSaasId) {
            const requestId = ++this.channelRequestId;
            const saasId = sourceSaasId || this.saasId;
            if (!saasId) {
                this.channelLoading = false;
                return;
            }
            this.channelLoading = true;
            const finish = () => {
                if (requestId === this.channelRequestId) {
                    this.channelLoading = false;
                }
            };
            const fail = () => {
                if (requestId === this.channelRequestId) {
                    this.sourceSaasId = '';
                }
                finish();
            };
            this.request({
                url: '/saas/channel/list',
                data: {
                    saas_id: saasId
                },
                loading: true,
                success: data => {
                    if (requestId === this.channelRequestId && Array.isArray(data)) {
                        // 复制来源商户时不带其店铺账号绑定（账号归属商户私有，需目标商户自行选择）
                        this.channelList = data.map(item => this.formatChannel(item, !!sourceSaasId));
                        // 预取各平台账号池选项，已绑店铺账号打开弹框即回显选中
                        this.loadAccountPoolOptions(this.channelList);
                    }
                },
                complete: finish,
                fail: fail,
                error: fail
            });
        },

        /*******格式化渠道数据********/
        formatChannel(item, copyFromSource) {
            // id 非空则自动选中
            const checked = !!item.id;
            let tierList = [];
            // 阶梯价配置集合从 sale_config 字段读取
            let rawTierList = item.sale_config;
            // 回填时如果阶梯价格是json字符串，则进行解析
            if (typeof rawTierList === 'string') {
                try {
                    rawTierList = JSON.parse(rawTierList);
                } catch (e) {
                    rawTierList = null;
                }
            }
            if (Array.isArray(rawTierList) && rawTierList.length > 0) {
                tierList = rawTierList.map(tier => this.formatTier(tier));
            }
            return {
                channel_id: item.channel_id || item.id,
                channel_name: item.channel_name || item.name,
                checked: checked,
                is_enabled: item.is_enabled,
                platform_code: item.platform_code || '',
                owner_type: item.owner_type,
                platform_account: copyFromSource ? '' : (item.platform_account || ''),
                tier_list: tierList
            };
        },

        /*******创建空阶梯数据********/
        createEmptyTier() {
            return {
                price: '',
                points: ''
            };
        },

        /*******格式化回填阶梯数据********/
        formatTier(tier) {
            return {
                price: tier.price !== undefined && tier.price !== null ? tier.price : '',
                points: tier.points !== undefined && tier.points !== null ? tier.points : ''
            };
        },

        /*******打开弹框即预取涉及平台的账号池（同平台会话内缓存复用），回显不依赖下拉展开*******/
        loadAccountPoolOptions(list) {
            const codes = [];
            list.forEach(channel => {
                if (channel.owner_type == 2 && channel.platform_code && codes.indexOf(channel.platform_code) === -1) {
                    codes.push(channel.platform_code);
                }
            });
            codes.forEach(code => {
                if (this.accountPoolCache[code]) {
                    this.setPoolOptions(code, this.accountPoolCache[code]);
                    return;
                }
                this.request({
                    url: '/channel/account/pool',
                    data: {
                        platform_code: code
                    },
                    success: data => {
                        const accounts = Array.isArray(data) ? data : [];
                        this.$set(this.accountPoolCache, code, accounts);
                        this.setPoolOptions(code, accounts);
                    },
                    // 池接口异常也要把已绑账号回显出来
                    fail: () => { this.setPoolOptions(code, []); },
                    error: () => { this.setPoolOptions(code, []); }
                });
            });
        },

        /*******单平台下拉选项组装：文案=用户名（手机号），有效性不进选项、只在右侧做异常提醒；已绑账号不在池结果里时补一项保证回显不丢*******/
        setPoolOptions(code, accounts) {
            const options = (accounts || []).map(acc => ({
                name: acc.username + '（' + (acc.phone || '未同步手机号') + '）',
                value: acc.username
            }));
            this.channelList.forEach(channel => {
                if (channel.owner_type == 2 && channel.platform_code == code && channel.platform_account
                        && !options.some(opt => opt.value == channel.platform_account)) {
                    options.unshift({ name: channel.platform_account, value: channel.platform_account });
                }
            });
            this.accountPoolOptions = Object.assign({}, this.accountPoolOptions, { [code]: options });
        },

        /*******当前已选账号授权是否过期（只作界面提醒，不拦保存、不影响推送）*******/
        isAccountExpired(channel) {
            if (!channel.platform_account) {
                return false;
            }
            const accounts = this.accountPoolCache[channel.platform_code];
            if (!Array.isArray(accounts)) {
                return false;
            }
            const acc = accounts.find(item => item.username == channel.platform_account);
            return !!(acc && acc.authorizationExpiresAt && new Date(acc.authorizationExpiresAt).getTime() < Date.now());
        },
        
        /*******切换渠道勾选状态********/
        toggleChannel(channel, checked) {
            channel.checked = checked;
            if (checked && (!channel.tier_list || channel.tier_list.length === 0)) {
                this.$set(channel, 'tier_list', [this.createEmptyTier()]);
            }
        },

        /*******增加阶梯********/
        addTier(channel) {
            if (!channel.tier_list) {
                this.$set(channel, 'tier_list', []);
            }
            channel.tier_list.push(this.createEmptyTier());
        },

        /*******删除阶梯********/
        removeTier(channel, tier, index) {
            if (tier.price || tier.points) {
                this.$confirm({
                    type: 'warn',
                    message: '是否确认删除该条阶梯数据？',
                    buttonName: '确认删除',
                    cancelButton: true,
                    resolve: () => {
                        channel.tier_list.splice(index, 1);
                    }
                });
            } else {
                channel.tier_list.splice(index, 1);
            }
        },

        /*******取消********/
        cancelHandle() {
            this.$refs.dialog.close();
            this.$emit('cancel');
        },

        /*******提交保存********/
        saveHandle() {
            if (this.channelLoading) {
                return;
            }
            const checkedChannels = this.channelList.filter(channel => channel.checked);

            // 校验已勾选的渠道
            for (let channel of checkedChannels) {
                if (!this.validateChannel(channel)) {
                    return;
                }
            }

            // 组装保存数据（按阶梯价格从小到大排序）
            const channelConfigList = checkedChannels.map(channel => {
                var sale_config = JSON.stringify(channel.tier_list.map(tier => ({
                    price: parseFloat(tier.price),
                    points: tier.points === '' || tier.points === null || tier.points === undefined ? 0 : parseFloat(tier.points)
                })).sort((a, b) => a.price - b.price));
                return {
                    channel_id: channel.channel_id,
                    sale_config: sale_config,
                    // 先删后插重存：三方渠道须随提交回显店铺账号；自营渠道不提交该字段（后端强制存NULL）
                    platform_account: channel.owner_type == 2 ? channel.platform_account : null
                };
            });

            this.request({
                url: '/saas/channel/batchSave',
                data: {
                    saas_id: this.saasId,
                    channel_list: channelConfigList
                },
                loading: true,
                success: (data, res) => {
                    this.$message({
                        message: '保存成功',
                        type: 'success'
                    });
                    this.$refs.dialog.close();
                    this.$emit('resolve');
                }
            });
        },

        /*******校验单个渠道配置********/
        validateChannel(channel) {
            const channelName = channel.channel_name || '未命名渠道';

            // 三方渠道必选平台店铺账号（推送中台nick_name唯一来源，未选直接拒绝提交）
            if (channel.owner_type == 2 && !String(channel.platform_account || '').trim()) {
                this.$message({
                    message: '【' + channelName + '】还未选择平台店铺账号，请在同售渠道配置中选择后保存',
                    type: 'warn'
                });
                return false;
            }

            // 已勾选的渠道至少需要填写一个阶梯
            if (!channel.tier_list || channel.tier_list.length === 0) {
                this.$message({
                    message: '【' + channelName + '】至少需要填写一个阶梯',
                    type: 'warn'
                });
                return false;
            }

            const priceSet = new Set();
            for (let i = 0; i < channel.tier_list.length; i++) {
                const tier = channel.tier_list[i];
                const rowText = '【' + channelName + '】第' + (i + 1) + '行';

                // 售价必须输入且必须大于0
                if (tier.price === '' || tier.price === null || tier.price === undefined) {
                    this.$message({
                        message: rowText + '的售价必须输入',
                        type: 'warn'
                    });
                    return false;
                }
                const price = parseFloat(tier.price);
                if (isNaN(price) || price <= 0) {
                    this.$message({
                        message: rowText + '的售价必须输入大于0的数字',
                        type: 'warn'
                    });
                    return false;
                }

                // 消耗积分可以不输入，输入了必须是非负数
                if (tier.points !== '' && tier.points !== null && tier.points !== undefined) {
                    const points = parseFloat(tier.points);
                    if (isNaN(points) || points < 0) {
                        this.$message({
                            message: rowText + '的消耗积分不能为负数',
                            type: 'warn'
                        });
                        return false;
                    }
                }

                // 检查价格重叠
                if (priceSet.has(price)) {
                    this.$message({
                        message: '【' + channelName + '】下阶梯价格存在重叠',
                        type: 'warn'
                    });
                    return false;
                }
                priceSet.add(price);
            }

            return true;
        }
    }
}
</script>

<style lang="stylus" scoped>
.saas-channel-config
    padding 20px

.source-saas
    display flex
    align-items center
    margin-bottom 20px
    .label
        flex-shrink 0
        color #606266
        margin-right 10px
    .c-select
        width 360px

.config-header
    margin-bottom 15px
    font-size 16px
    font-weight bold
    color #303133

.channel-list
    .channel-item
        margin-bottom 12px
        border 1px solid #e4e7ed
        border-radius 6px
        background #fff
        overflow hidden
        &.active
            border-color #c6e2ff
            background #f5f9ff

.channel-header
    padding 12px 15px
    background #fafafa
    .active &
        background #eaf4ff

.channel-body
    padding 20px 15px 20px 25px

.platform-account
    display flex
    align-items center
    margin-bottom 15px
    .label
        color #606266
        margin-right 8px
        flex-shrink 0
    .required
        color #ff4d4f
        margin-right 4px
    .c-select
        width 360px
        flex-shrink 0
    .account-tip
        margin-left 12px
        color #999
        font-size 12px
        &.is-expired
            color #ff4d4f

.consume-type
    margin-bottom 15px
    .required
        color #ff4d4f
        margin-right 4px
    .label
        color #606266
    .type-tag
        display inline-block
        padding 6px 8px
        background #1890ff
        color #fff
        border-radius 4px
        font-size 12px

.tier-row
    display flex
    align-items center
    margin-bottom 12px
    flex-wrap nowrap
    &:last-child
        margin-bottom 0

    .row-label
        white-space nowrap
        margin-right 5px
        color #606266
        flex-shrink 0

    .input-wrap
        width 140px
        flex-shrink 0

    .link-btn
        cursor pointer
        font-size 14px
        white-space nowrap
        flex-shrink 0
        &.add
            color #1890ff
        &.delete
            color #ff4d4f
            margin-left auto
            padding-left 15px

.add-row
    margin-top 20px
</style>
